<template>
  <div class="lawsardet">
    <div class="articltitle">强令违章冒险作业罪既遂刑事责任如何追究</div>
    <div class="label center">
      <div class="laiyuan">来源：<span>律观网</span></div>
      <div class="time">2021-04-23</div>
      <div class="dskg"><span>178</span> 人看过</div>
    </div>
    <div class="zhenwen" v-html="zhengwen"></div>
    <div class="lawdetstment">
      声明：法律快车以学习交流为目的，整合法律法规、政府官网及互联网相关知识，遵守本网站规章制度刊载发布各类法律性内容，包括但不限于知识、案例、范本和法规等。如果涉及版权、商誉等问题，请联系我们，并提交问题、链接及权属信息，我们将第一时间核实后根据相关法律规定及时给予处理。
      [反馈渠道]
    </div>
    <ul class="stretchtm mt30">
      <div class="bt">
        <img src="../../../assets/laws/lawsarticalysread.png" />延伸阅读：
      </div>
      <li>强令违章冒险作业罪既遂有哪些惩罚</li>
      <li>强令违章冒险作业罪既遂有哪些惩罚</li>
      <li>强令违章冒险作业罪既遂有哪些惩罚</li>
    </ul>
    <ul class="stretchtm mt30">
      <div class="bt">
        <img src="../../../assets/laws/lawsarticalyingy.png" />引用法条：
      </div>
      <li>《中华人民共和国刑法》第一百三十四条</li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      zhengwen: `为深入推进量刑规范化改革，进一步扩大量刑规范化范围，根据刑法、刑事司法解释等相关规定，结合刑事审判实践，制定本指导意见。

一、八种常见犯罪的量刑

(一)危险驾驶罪

1.构成危险驾驶罪的，可以在一个月至二个月拘役幅度内确定量刑起点。

2.在量刑起点的基础上，可以根据危险驾驶行为等其他影响犯罪构成的犯罪事实增加刑罚量，确定基准刑。

3.对于醉酒驾驶机动车的被告人，应当综合考虑被告人的醉酒程度、机动车类型、车辆行驶道路、行车速度、是否造成实际损害以及认罪悔罪等情况，准确定罪量刑。对于情节显著轻微危害不大的，不予定罪处罚；犯罪情节轻微不需要判处刑罚的，可以免予刑事处罚。

(二)非法吸收公众存款罪

1.构成非法吸收公众存款罪的，可以根据下列不同情形在相应的幅度内确定量刑起点：

(1)犯罪情节一般的，可以在一年以下有期徒刑、拘役幅度内确定量刑起点。

(2)达到数额巨大起点或者有其他严重情节的，可以在三年至四年有期徒刑幅度内确定量刑起点。

2.在量刑起点的基础上，可以根据非法吸收存款数额等其他影响犯罪构成的犯罪事实增加刑罚量，确定基准刑。

(三)集资诈骗罪

1.构成集资诈骗罪的，可以根据下列不同情形在相应的幅度内确定量刑起点：

(1)达到数额较大起点的，可以在二年以下有期徒刑、拘役幅度内确定量刑起点。

(2)达到数额巨大起点或者有其他严重情节的，可以在五年至六年有期徒刑幅度内确定量刑起点。

(3)达到数额特别巨大起点或者有其他特别严重情节的，可以在十年至十二年有期徒刑幅度内确定量刑起点。依法应当判处无期徒刑的除外。

2.在量刑起点的基础上，根据集资诈骗数额等其他影响犯罪构成的犯罪事实增加刑罚量，确定基准刑。

(四)信用卡诈骗罪

1.构成信用卡诈骗罪的，可以根据下列不同情形在相应的幅度内确定量刑起点：

(1)达到数额较大起点的，可以在二年以下有期徒刑、拘役幅度内确定量刑起点。

(2)达到数额巨大起点或者有其他严重情节的，可以在五年至六年有期徒刑幅度内确定量刑起点。

(3)达到数额特别巨大起点或者有其他特别严重情节的，可以在十年至十二年有期徒刑幅度内确定量刑起点。依法应当判处无期徒刑的除外。

2.在量刑起点的基础上，可以根据信用卡诈骗数额等其他影响犯罪构成的犯罪事实增加刑罚量，确定基准刑。`,
    };
  },
};
</script>

<style lang="scss" scoped>
.lawsardet {
  padding: 30px 30px 40px;
  .articltitle {
    font-size: 24px;
    color: #333333;
    text-align: center;
  }
  .label {
    margin-top: 24px;
    font-size: 12px;
    color: #bbbbbb;
    .laiyuan {
      border-right: 1px solid #dddddd;
      padding-right: 20px;
      margin-right: 20px;
      span {
        color: #777;
      }
    }
    .time {
      border-right: 1px solid #dddddd;
      padding-right: 20px;
      margin-right: 20px;
    }
    .dskg {
      span {
        color: #dc0000;
      }
    }
  }
  .zhenwen {
    margin-top: 24px;
    line-height: 40px;
  }
  .lawdetstment {
    font-size: 12px;
    color: #999999;
    line-height: 32px;
  }
  .stretchtm {
    .bt {
      font-size: 18px;
      color: #333333;
      img {
        vertical-align: -0.15em;
        width: 24px;
        height: 18px;
        margin-right: 11px;
      }
    }
    li {
      cursor: pointer;
      margin-top: 20px;
      margin-left: 34px;
      color: #666666;
      list-style: disc;
      &:hover {
        color: #0465ea;
      }
    }
  }
}
</style>